import * as React from "react";
import { forwardRef } from "react";
const SvgCs = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "flag-icons-cz", viewBox: "0 0 640 480", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h640v240H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#d7141a", d: "M0 240h640v240H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#11457e", d: "M360 240 0 0v480z" }));
const ForwardRef = forwardRef(SvgCs);
export default ForwardRef;
